import { schema } from 'normalizr';

// Entidad Canal de Distribución (PK distributionChannelId)
export const distributionChannel = new schema.Entity(
  'distributionChannels',
  {},
  { idAttribute: 'distributionChannelId' }
);

export const distributionChannels = [distributionChannel];
